import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "../commonFields";

export const codeSnippetBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Code snippet",
  inputs: [
    {
      name: "copyLabel",
      type: "string",
      friendlyName: "Copy Button Label",
      helperText: "Label for the copy code button.",
      localized: true,
      defaultValue: {
        "@type": "@builder.io/core:LocalizedValue",
        Default: "Copy",
      },
    },
    DLD_FIELD,
    DLT_FIELD,
    {
      name: "language",
      type: "enum",
      friendlyName: "Programming Language",
      helperText: "The programming language of the code snippet.",
      enum: [
        { label: "Bash", value: "bash" },
        { label: "C", value: "c" },
        { label: "C++", value: "cpp" },
        { label: "C#", value: "csharp" },
        { label: "CSS", value: "css" },
        { label: "Diff", value: "diff" },
        { label: "Go", value: "go" },
        { label: "HTML", value: "html" },
        { label: "INI", value: "ini" },
        { label: "Java", value: "java" },
        { label: "JavaScript", value: "javascript" },
        { label: "JSON", value: "json" },
        { label: "Kotlin", value: "kotlin" },
        { label: "Lua", value: "lua" },
        { label: "Makefile", value: "makefile" },
        { label: "Markdown", value: "markdown" },
        { label: "Objective-C", value: "objectivec" },
        { label: "Perl", value: "perl" },
        { label: "PHP", value: "php" },
        { label: "Plain text", value: "plaintext" },
        { label: "Python", value: "python" },
        { label: "Ruby", value: "ruby" },
        { label: "Rust", value: "rust" },
        { label: "SCSS", value: "scss" },
        { label: "SQL", value: "sql" },
        { label: "Swift", value: "swift" },
        { label: "TypeScript", value: "typescript" },
        { label: "XML", value: "xml" },
        { label: "YAML", value: "yaml" },
      ],
    },
    {
      name: "code",
      type: "code",
      friendlyName: "Code",
      helperText:
        "The code snippet to display. To pick the language, please use the Language dropdown above.",
    },
  ],
};
